export const flattenOptions = (options) =>
  options.length && 'options' in options[0]
    ? options.flatMap((group) => group.options)
    : options;
